<ng-container *ngIf="pageReady">
    <div class="row mb-2" *ngIf="!lazy">
        <div class="col-md-12 mb-2" *ngIf="title > ''">
            <h5 [ngClass]="cssClass">{{ title }}</h5>
        </div>
        <div class="row spinner" *ngIf="loading">
            <div class="col-md-12 mb-3 align-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ configService.getTranslation('common.loading')}}</span>
              </div>
            </div>
        </div>
        <ng-container *ngIf="items && items.length > 0">
            <div class="col-md-12" *ngFor="let item of items">
                <ng-container *ngIf="currentId">
                    <a *ngIf="item.id !== currentId" [routerLink]="['/' + collectionForm.collection + '/' + item.id + '/' + configService.env.currentLang]" [queryParams]="{
                        status: item.status
                    }">{{ item.document.title + " (" + item.document.references.reportingYear + ")" }}</a>
                    <label *ngIf="item.id === currentId">{{ item.document.title }}<ng-container *ngIf="!mostRecent">{{ " (" + item.document.references.reportingYear + ")" }}</ng-container></label>
                </ng-container>
                <ng-container *ngIf="!currentId">
                    <a [routerLink]="['/' + collectionForm.collection + '/' + item.id + '/' + configService.env.currentLang]" [queryParams]="{
                        status: item.status
                    }">{{ item.document.title }}<ng-container *ngIf="!mostRecent">{{ " (" + item.document.references.reportingYear + ")" }}</ng-container></a>
                </ng-container>
            </div>
        </ng-container>
        <div class="col-md-12" *ngIf="!loading && (!items || items?.length === 0)">
            <label class="no-data-found">No other observations available</label>
        </div>
    </div>
    <div class="row mb-2" *ngIf="lazy">
        <div class="col-md-12 mb-2" *ngIf="title > ''">
            <h6 [ngClass]="cssClass">{{ title }}</h6>
        </div>
        <div class="col-md-12">
            <ul>
                <li *ngFor="let ids of inventoryId">
                    <a *ngIf="ids.value !== currentId" href="javascript:void(0)" (click)="getFactsheets(ids.value, ids)">{{ ids.label }}</a>
                    <div class="row spinner" *ngIf="ids.loading">
                        <div class="col-md-12 mb-3 align-center">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">{{ configService.getTranslation('common.loading')}}</span>
                          </div>
                        </div>
                    </div>                    
                    <ul *ngIf="ids.open && ids.items && ids.items.length > 0">
                        <li *ngFor="let item of ids.items">
                            <a [routerLink]="['/' + collectionForm.collection + '/' + item.id + '/' + configService.env.currentLang]" [queryParams]="{
                                status: item.status
                            }">{{ item.document.title + " (" + item.document.references.reportingYear + ")" }}</a>
                        </li>
                    </ul>
                    <div class="row mt-2 mb-2" *ngIf="ids.open && !ids.loading && (!ids.items || ids.items?.length === 0)">
                        <div class="col-md-12">
                            <label class="no-data-found">No other observations available</label>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</ng-container>